import * as React from 'react';
import { useContext, useEffect, useRef } from 'react';
import { useI18n } from '../../../Translation';
import Spinner from '../Spinner';
import { useUpdateCourseProgress } from './Hooks/useUpdateCourseProgress';
import { useCheckLectureWatchtime } from './Hooks/useCheckLectureWatchtime';
import { toast } from 'react-hot-toast';
import { AdminRoutesContext } from './AdminRoutesContext';
const CourseLectureProgressButton = (props) => {
    const { isPreviewMode } = useContext(AdminRoutesContext);
    const mutation = useUpdateCourseProgress();
    const { data: watchtimeData, isLoading: isCheckingWatchtime } = useCheckLectureWatchtime({
        courseUuid: props.courseUuid,
        lectureUuid: props.lectureUuid,
    });
    const i18n = useI18n();
    // Store token once received (persist across re-renders)
    const completionTokenRef = useRef(null);
    // Update ref when token is received
    useEffect(() => {
        if (watchtimeData?.completionToken) {
            completionTokenRef.current = watchtimeData.completionToken;
        }
    }, [watchtimeData?.completionToken]);
    const canProgress = watchtimeData?.hasAccess ?? false;
    const percentage = watchtimeData?.percentage ?? 0;
    const threshold = watchtimeData?.threshold ?? 85;
    const completionToken = completionTokenRef.current ?? watchtimeData?.completionToken;
    useEffect(() => {
        if (mutation.data && !mutation.data.success) {
            if (mutation.data.reason === 'invalid_completion_token') {
                // Token was invalid, clear it and let user retry
                completionTokenRef.current = null;
            }
            toast.error(i18n['course.watchtime.threshold']);
        }
    }, [mutation.data]);
    if (isPreviewMode) {
        return (<div className="inline-flex items-center gap-x-2 rounded-md bg-gray-100 px-3.5 py-2.5 text-sm font-medium text-gray-500 border border-gray-200">
                Vorschau — kein Fortschritt wird gespeichert
            </div>);
    }
    const handleClick = () => {
        if (!canProgress || !completionToken) {
            toast.error(`${i18n['course.watchtime.threshold']} (${Math.round(percentage)}% / ${threshold}%)`);
            return;
        }
        mutation.mutate({
            courseUuid: props.courseUuid,
            lectureUuid: props.lectureUuid,
            completionToken,
        });
    };
    return <>
        <button type="button" className={`inline-flex items-center gap-x-2 rounded-md px-3.5 py-2.5 text-base font-semibold text-white shadow-sm md:bottom-24 md:right-12 ${canProgress ? 'bg-brand-secondary hover:bg-brand-secondary-dark' : 'bg-gray-400 cursor-not-allowed opacity-60'}`} onClick={handleClick} disabled={!canProgress || mutation.isPending || isCheckingWatchtime}>
            {mutation.isPending || isCheckingWatchtime ? (<Spinner />) : (<>
                    {i18n['course.finishLecture']}
                    {!canProgress && ` (${Math.round(percentage)}%)`}
                </>)}
        </button>
    </>;
};
export default CourseLectureProgressButton;
